var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogonew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9d3a8e;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #5ab948;\n      }\n\n      .cls-3 {\n        fill: #008f48;\n      }\n\n      .cls-4 {\n        fill: #0a4e97;\n      }\n\n      .cls-5 {\n        fill: #407f3d;\n      }\n\n      .cls-6 {\n        fill: #aad048;\n      }\n\n      .cls-7 {\n        fill: #8bc542;\n      }\n\n      .cls-8 {\n        fill: #218341;\n      }\n\n      .cls-9 {\n        fill: #ee2524;\n      }\n\n      .cls-10 {\n        fill: #298b44;\n      }\n\n      .cls-11 {\n        fill: #34b44a;\n      }\n\n      .cls-12 {\n        fill: #164f94;\n      }\n\n      .cls-13 {\n        fill: #232323;\n      }\n\n      .cls-14 {\n        fill: #f89424;\n      }\n\n      .cls-15 {\n        fill: #e83929;\n      }\n\n      .cls-16 {\n        fill: #f78f1e;\n      }\n\n      .cls-17 {\n        fill: #7ac143;\n      }\n\n      .cls-18 {\n        fill: #fff;\n      }\n\n      .cls-19 {\n        fill: #b5d55e;\n      }\n\n      .cls-20 {\n        fill: #a82e90;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M0,0h170v155.1c0,7.7-6.2,13.9-13.9,13.9H13.9c-7.7,0-13.9-6.2-13.9-13.9V0h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M77,83.1l3.5-1.2s-2.1-1.5-1.7-4.4c.7-5.1,5.1-10.8,1.9-17,0,0,1.2,2.5-.8,7.1-1.8,4.1-5.8,10-2.9,15.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M78.2,72c0-4-4.5-6.8-4.5-6.8,0,0,3.2,3.2,2.6,7.3-.6,4-1.4,6.8.7,10.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80.8,81.8s-1.5-3.6,2.9-4.2c0,0-1.8,0-2.2-1.7s.4-4.1,0-6.2c0,0,0,1-.8,2.8s-1.2,3.5-1.4,5.1c-.2,1.6.7,3,1.5,4.1h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 83.3,
    cy: 74.9,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71,59.8s-.5,2.3,1.6,4.6,3.2,3.7,3.3,5.9c0,0-.7-2.4-3.6-4.1-2-1.1-4-.7-4.9,0,0,0,.8-1.5,3.2-2.1,0,0-.7-2.3.3-4.2h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 68.7,
    cy: 62.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 77.9,
    cy: 65.6,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 75,
    cy: 51.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M71.6,52.2s2.9,1,5.6,4.3c2.7,3.4,3.4,6.8,3.2,8.6,0,0,.8-3.5-.7-6.8-1.7-4-2.1-7.8-.5-9.9,0,0-2.6,1.9-2.5,5.5,0,0-1.8-2-5.1-1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M66.6,65.4s0,2.3-2.2,2.7c0,0-.2-2.1,2.2-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64.9,64.3s-.2,2.3-2.5,2.4c0,0,0-2.1,2.5-2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61.2,62s-1.4,1.8-3.4.7c0,0,1.1-1.7,3.4-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M60.9,56.6s-2.1,1-3.3-1c0,0,1.8-1,3.3,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.8,55.2s-2.2.8-3.2-1.3c0,0,1.9-.8,3.2,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.5,51s-2.1.9-3.3-1.1c0,0,1.8-1,3.3,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M67.3,46.3s-2.2-.7-1.8-3c0,0,2,.5,1.8,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M82.3,49.7s1-2.1,3.2-1.3c0,0-.8,1.9-3.2,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M82,58.8s2.2-.7,3.2,1.5c0,0-1.9.7-3.2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M84.1,57.1s2.2-.7,3.2,1.4c0,0-1.9.8-3.2-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61.8,59.7s-2.6,1.5-4-.7c0,0,2-1.5,4,.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M71.1,44.8s-2.4-1-1.7-3.6c0,0,2.2.8,1.7,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.6,43.8s-1.3-2.3.8-3.9c0,0,1.3,2-.8,3.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M71.8,60.2s.8,1.3,2.6.4c0,0-1.1-1.2-2.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M76.3,57.8s.7,1.4-1.1,2.4c0,0-.4-1.6,1.1-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M73,57.1s2.2.6,1.8,3.2c0,0-2.1-.4-1.8-3.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M68.1,57.6s1.2.9,2.5-.6c0,0-1.5-.7-2.5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M71.2,53.8s1.1,1,0,2.6c0,0-1-1.3,0-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M67.9,54.4s2.2-.3,2.8,2.3c0,0-2.1.4-2.8-2.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M79.2,44.6s-.7,1.4,1.1,2.4c0,0,.4-1.6-1.1-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M83.6,47s-.8,1.3-2.6.4c0,0,1.1-1.2,2.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M82.3,43.9s.7,2.1-1.6,3.2c0,0-.9-2,1.6-3.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M63,62.4s1.8.7,2.9-1.2c0,0-2-.7-2.9,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M66.1,57.3s-1.3,1.4.2,3.2c0,0,1.3-1.6-.2-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M62.4,58.6s.5,2.7,3.7,2.2c0,0-.7-2.7-3.7-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M71.4,47.1s.9,1.7,3,1c0,0-1-1.8-3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M77.2,45.3s-1.9.2-1.9,2.5c0,0,2-.4,1.9-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M73.5,43.8s-1.4,2.3,1.3,4.1c0,0,1.3-2.5-1.3-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M64.1,51.6s1.8,1,3.3-.9c0,0-2-1-3.3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M68.4,46.5s-1.6,1.3-.3,3.5c0,0,1.7-1.5.3-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M64.1,47.3s0,3,3.6,3c0,0-.3-3.1-3.6-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M80.6,50.3s-1.8,1.1-.7,3.4c0,0,1.8-1.3.7-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M83.2,56.5s-.5-2-3-1.8c0,0,.7,2.2,3,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M84.4,52.3s-2.7-1.3-4.3,1.8c0,0,2.8,1.2,4.3-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68.2,51s1,1.5,2.6.7c0,0-.8-1.7-2.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M83.4,55s2.2-1.5,4.1,1c0,0-2.4,1.3-4.1-1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M148.6,96.4c-1.6-.2-3.4-.2-5.3-.2-3.6,0-7.2.2-10.4.5.2,2.2.2,2.3.3,3.9v2c.1,2.1,5.2,3.6,10.2,3.7,8,.2,18-2.2,19.6-4.8-.7-1.8-3.5-4.2-14.4-5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M20.6,90.1c-.5.6-.8,1.4-.8,2.2.9,0,1.9.2,2.9.2,1.9,0,3.8.2,5.7.2h2.4v-.3c0-30,24.4-54.4,54.4-54.4s38.6,11.5,47.8,28.4c1.7,0,3.4-.2,5-.2s2.8,0,4.2,0c1.1,0,2.1,0,3,.2-.2-1.1-.9-2-1.9-2.5l-2.3-1.1c-1.5-.7-2.6-2.6-2.4-4.2l.2-2.6c.1-1.6-1.1-3.2-2.6-3.6l-2.5-.6c-1.6-.4-3-2-3.2-3.6l-.3-2.5c-.2-1.6-1.7-3-3.3-3h-2.6c-1.6,0-3.4-1.4-3.9-2.9l-.8-2.4c-.5-1.5-2.3-2.5-3.9-2.2l-2.5.5c-1.6.3-3.6-.6-4.4-2l-1.3-2.2c-.8-1.4-2.8-2-4.2-1.4l-2.4,1c-1.5.6-3.6.2-4.7-1l-1.8-1.9c-1.1-1.2-3.1-1.4-4.4-.5l-2.1,1.5c-1.3.9-3.5.9-4.8,0l-2.1-1.5c-1.3-.9-3.3-.7-4.4.5l-1.8,1.9c-1.1,1.2-3.2,1.6-4.7,1l-2.4-1c-1.5-.6-3.4,0-4.2,1.4l-1.3,2.2c-.8,1.4-2.8,2.3-4.4,2l-2.5-.5c-1.6-.3-3.3.7-3.9,2.2l-.9,2.4c-.5,1.5-2.3,2.8-3.9,2.8h-2.6c-1.6,0-3.1,1.5-3.3,3.1l-.3,2.5c-.2,1.6-1.7,3.2-3.2,3.6l-2.5.6c-1.6.4-2.8,2-2.6,3.6l.2,2.5c0,1.6-1,3.5-2.4,4.2l-2.3,1.1c-1.5.7-2.3,2.5-1.8,4.1l.7,2.5c.5,1.5-.2,3.6-1.5,4.6l-2,1.6c-1.3,1-1.7,2.9-.9,4.4l1.2,2.2c.8,1.4.5,3.6-.5,4.8l-1.7,1.9h-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M22.7,92.5c1.4,0,2.8,0,4.1.2-.2-3.7-.1-2.7-.3-6.5-.1-2.2-3.1-3-6.4-3.1h-.6c-5.2,0-11.6,1.9-12.5,4.4.6,1.9,5,4.4,15.7,5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M7.4,89.8l1.8,19.3c.6,6.4,1.3,8.8,10.4,10.8,3.8.8,7.9,1.2,12.3,1.2s12.3-.8,17.6-1.5c14.2-1.9,27.8-7.1,40.9-12.1,10.3-3.9,21.1-8,32.1-10.6,3.1-.7,11.6-1.7,19.7-1.7s3.6,0,5.3.2c8.3.5,13.4,1.8,15.4,3.7l-1.8-19.3c-.7-7.6-3.7-10.9-20.1-11.8-1.3,0-2.7,0-4.1,0-4.8,0-10,.5-16.2,1.5-13.9,2.3-26.6,7.1-38.9,11.7-16.5,6.2-33.6,12.7-53.5,12.7s-3.8,0-5.7-.2c-8.3-.5-13.4-1.8-15.4-3.8h.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M50.8,112.8c0,.6-.3.9-1.1,1.1-1.1.2-2.3-.2-3.7-1.2s-2.4-2-3.1-3.2c0,.7-.2,1.2-.3,1.4s0,.7-.2,1.2c0,.6-.2,1-.2,1.2,0,.3,0,.6-.2.8,0,.6-.3.9-.5.9-.3,0-.8-.2-1.3-.6s-.8-.9-.9-1.2c0-.3,0-1,.2-2,.5-3,.7-5.6.5-7.9-.3-.2-.6-.4-.9-.8s-.4-.7-.5-.9c0-.4.4-.9,1.4-1.6,1-.6,2.2-1.1,3.7-1.3,1.4-.2,2.7,0,3.8.5s1.7,1.3,1.8,2.4c0,.8,0,1.6-.4,2.4s-.8,1.5-1.3,2l-1.4,1.4c-.4.4-.6.7-.6.8,0,.3.2.7.5.9.3.3.7.6,1.1.9s.9.6,1.2.9.6.4.8.6.4.3.7.5c.4.3.7.6.7.8h.2ZM46.2,102.4c0-.6-.7-.8-1.9-.6-.5,0-1.2.3-1.9.8.4.5.7.9.8,1.4,0,.8.2,1.7,0,2.8,0,0,.4-.4.8-.7.4-.3.7-.6.9-.8s.4-.5.7-.8c.5-.6.7-1.3.6-1.9h0v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M52.4,104.3c.7-1.8,1.5-2.9,2.6-3.2s2,0,3,.4c.9.6,1.5,1.3,1.8,2.4s.3,2.2,0,3.4c-.2,1.2-.7,2.3-1.4,3.2s-1.6,1.6-2.6,1.8c-.8.2-1.5,0-2.2-.5s-1.2-1.3-1.5-2.2c-.5-1.7-.3-3.5.3-5.3h0ZM56.9,107.7c.3-1.2.3-2.2,0-3.1-.2-.9-.5-1.5-.8-1.7-.5.5-.9,1.4-1.2,2.7s-.3,2.3,0,3.2.4,1.3.7,1.5c.7-.5,1.1-1.4,1.4-2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M66.2,97.7c.5-.2,1.1,0,1.8.4s1.1.9,1.3,1.4c0,.3,0,.5-.3.6h-.8c-.4,0-.7,0-1,0s-.8.4-1.3.8-.8.8-.6,1.2c0,0,.3.3.8.4.4,0,.9.3,1.5.4.5,0,1.1.4,1.6.7s.9.8,1.1,1.4,0,1.3-.7,2.1-1.5,1.4-2.6,1.8-2.1.4-3.1.2-1.5-.6-1.7-1.2c-.2-.5,0-.9.4-1h.7c.8.2,1.7,0,2.7-.2s1.5-.6,1.4-.9c0-.3-.4-.5-.9-.7s-1-.4-1.6-.5-1.1-.3-1.6-.6c-.5-.3-.8-.6-1-1-.2-.7.2-1.8,1.2-3.1,1-1.3,1.9-2.1,2.7-2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M71.5,90.4c.7.4,1.2.9,1.4,1.4s.5,1.5.8,3c.3,1.4.6,2.6.7,3.5.7,5.3.8,8,.3,8.2-.3,0-.8,0-1.4-.3s-1-.6-1.1-.9c0,0,0-.8-.2-2.3,0-1.5-.4-3.4-.8-5.7s-1-4.4-1.7-6.4c0-.4,0-.7.4-.8.3,0,.8,0,1.6.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M75.4,91.5c0-.3,0-.8,0-1.2s.4-.8.7-.9.8,0,1.5.7,1.1,1,1.2,1.3,0,.6,0,.9-.3.4-.6.5c-.4.2-.9,0-1.6-.3s-1.1-.7-1.2-1h0ZM76.6,93.9c.5-.2,1,0,1.6.3s.9.8,1.1,1.3c0,.2.2,1.3.3,3s.2,3.4.3,5c0,.6-.2,1-.7,1.2-.3,0-.6,0-.9,0s-.5-.4-.7-.7c0-.3-.3-1.3-.5-2.8s-.4-2.8-.6-3.9-.3-1.9-.3-2.4,0-.8.3-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M86.9,90c.7-.3,1.4-.2,2.2.2s1.3,1,1.5,1.7c.4,1.1.7,2.4.8,3.8s0,2.5,0,3.3c-.2.8-.5,1.3-.9,1.5s-.8,0-1-.7c-.2-.5-.3-1.5-.4-3.2,0-1.3-.3-2.3-.5-2.8s-.4-.8-.5-.7c-.2,0-.3.2-.4.4s-.2.4-.2.6,0,.4-.2.7,0,.5-.2.7c0,.2,0,.5,0,.8s0,.6,0,.8,0,.5,0,.8c-.4,2.8-.9,4.3-1.6,4.6-.3,0-.7,0-1.3-.3s-1-.6-1.1-.8v-3.3c0-.3,0-.7-.2-1s-.2-.6-.2-.8,0-.5-.3-.9c-.5-1.8-.8-2.8-.8-3s0-.3.2-.4c.5-.2,1.1-.2,1.7,0s1,.5,1.1.9c.3.8.5,2.1.7,3.8.3-1.8.6-3.4,1-4.6.3-1.2.8-1.9,1.3-2.1h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M97.6,79.9c.3,0,.8,0,1.6.4s1.2.9,1.3,1.4c0,.3.2,1.4.4,3.4.2,2,.3,3.3.3,3.7.5,5,.5,7.7,0,7.8-.3,0-.7,0-1.1-.2-.5-.2-.8-.5-.9-.8v-.2c-1,1.6-1.8,2.5-2.3,2.7s-1.3,0-2-.4c-.8-.4-1.2-.9-1.4-1.4s-.3-1.1-.4-1.8,0-1.4,0-2.2.2-1.6.4-2.3.5-1.4.9-2,.9-1,1.5-1.2c.9-.3,1.7,0,2.6.6-.4-3.5-.7-5.7-1.1-6.8,0-.4,0-.7.4-.8h-.2ZM96.2,95.5c.3,0,.8-.6,1.4-1.5.6-.8,1-1.8,1.1-2.8,0,0,0-.3-.3-.7,0-.4-.4-.7-.7-.9s-.6-.3-.8-.3c-.4,0-.7.5-.9,1.1s-.3,1.2-.4,1.8c0,1.4,0,2.4.3,3.1,0,0,0,.2,0,.2h.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M112.4,87.1c.3.2.5.3.5.5v5.4c0,0-.2.2-.4.3-.2,0-.5,0-.9-.4-.4-.3-.7-.7-1-1.2-.9,1.7-1.8,2.6-2.7,2.9-.6.2-1.3,0-2.2-.5s-1.4-1-1.6-1.7,0-1.7,0-3.1c.3-1.4.8-2.7,1.5-4s1.6-2.1,2.6-2.4c.6-.2,1.3,0,2.3.5s1.5,1,1.6,1.5,0,1.3,0,2.1h.2ZM107.3,92c.6-.2,1.2-.7,1.9-1.7.7-1,1-2.1.9-3.3,0-.2,0-.3.3-.4-.3-.8-.5-1.1-.7-1.1-.6.2-1.1.7-1.6,1.6s-.8,1.8-1.1,2.8c-.2.9-.3,1.6-.2,2,0,0,0,.2,0,.2h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M116.5,76c.7.5,1.1,1,1.2,1.6s.2,1.6.4,3.1c0,1.5.2,2.7.2,3.5,0,5.3-.4,8-.8,8.1-.3,0-.7,0-1.3-.5-.6-.4-.9-.8-.9-1.1,0,0,0-.8,0-2.3s0-3.4,0-5.8-.3-4.5-.8-6.6c0-.4,0-.7.5-.7s.8.2,1.5.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M128.3,85.2c-.9.7-1.8,1.1-2.8,1.2s-1.8.2-2.5,0v1.2c0,.4.2.7.3.8s.5.2,1,0c1.1-.2,2-.4,2.7-.7.7-.3,1.1-.5,1.1-.5.6,0,.9,0,.9.4,0,.6-.3,1.1-1.1,1.8s-1.9,1-3.1,1.2-2.2,0-3-.7-1.3-1.5-1.5-2.5,0-2.1.4-3.3c.4-1.2,1.1-2.2,1.9-3.1s1.6-1.4,2.5-1.5,1.8.2,2.7,1,1.4,1.6,1.5,2.5c.1.7-.3,1.4-1.1,2.1h.1ZM126.4,82.6c-.3-.2-.6-.3-.9-.3s-.6.3-.9.7c-.4.4-.7,1-1,1.6h.6c1.9-.3,2.9-.8,2.8-1.4,0,0-.2-.3-.5-.6h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M91.1,131c.4.4.6.8.6,1.2s0,1.1-.2,2.1-.2,1.8-.4,2.4c-.8,3.5-1.4,5.2-1.7,5.2s-.5-.2-.8-.5-.5-.6-.5-.8,0-.5.4-1.5.5-2.2.8-3.8c.3-1.5.4-3,.4-4.4s.2-.4.5-.4.5.2.9.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M38.9,131.5c.5,0,1.3-.1,2.4-.1s1.9,0,2.4.2.8.4.8.7,0,.2-.2.3c0,0-.2.1-.3.1h-2.8c-.2,0-.7,0-1.5.2h0c0,.4-.2,1.3-.5,2.8h3.1c.2,0,.3,0,.4.1s.2.2.2.3c0,.3-.2.5-.5.7s-.7.4-1.2.5c-.9.2-1.8.4-2.5.4-.3,1.2-.5,2-.5,2.2,0,.3,0,.5-.2.8,0,.5-.2.7-.3.7-.2,0-.5-.2-.8-.7-.3-.4-.5-.8-.5-1,0-.4.2-1.6.7-3.6.5-2.1.7-3.3.8-3.9h0v-.4c0-.3.4-.5,1-.6h0v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M45.4,135.9c.8-1.1,1.5-1.6,2.3-1.6s1.4.3,1.9.8.8,1.1.8,1.9-.2,1.5-.5,2.2-.8,1.4-1.5,1.9c-.6.5-1.3.7-2,.7s-1-.2-1.4-.7-.6-1-.6-1.7c0-1.2.4-2.3,1.1-3.4h0ZM47.8,138.9c.4-.7.6-1.4.6-2s0-1-.3-1.3c-.4.2-.8.7-1.3,1.5-.4.8-.6,1.4-.6,2s0,.9.2,1.1c.5-.2,1-.7,1.4-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M52.3,135.9c.8-1.1,1.5-1.6,2.3-1.6s1.4.3,1.9.8.8,1.1.8,1.9-.2,1.5-.5,2.2-.8,1.4-1.5,1.9c-.6.5-1.3.7-2,.7s-1-.2-1.4-.7-.6-1-.6-1.7c0-1.2.4-2.3,1.1-3.4h0ZM54.7,138.9c.4-.7.6-1.4.6-2s0-1-.3-1.3c-.4.2-.8.7-1.3,1.5-.4.8-.6,1.4-.6,2s0,.9.2,1.1c.5-.2,1-.7,1.4-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M64.4,130.3c.2,0,.6.2.9.6.4.4.6.8.6,1.2s-.2.9-.5,2.3-.6,2.1-.6,2.4c-.8,3.3-1.4,4.9-1.7,4.9s-.4-.1-.7-.4c-.3-.2-.4-.5-.4-.7s0,0,0-.1c-1,.8-1.7,1.2-2.1,1.2s-.8-.2-1.2-.7c-.4-.4-.6-.9-.6-1.2s0-.8.2-1.2.3-.9.5-1.4.5-1,.7-1.4.6-.8,1-1.1.8-.4,1.2-.4c.6,0,1.2.3,1.5.9.5-2.3.8-3.8.8-4.5s0-.4.4-.4h0ZM60,139.9c.2,0,.7-.2,1.2-.6s1-.9,1.3-1.6v-.5c0-.3,0-.5-.3-.7s-.3-.4-.5-.4c-.3,0-.6.1-.8.5s-.5.7-.6,1.1c-.3.9-.5,1.6-.5,2s0,.1,0,.1h.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M78.1,131.2c.3,0,.6.2.9.7s.5.9.5,1.2,0,.5-.2.5h-.9c-.5,0-1.1.3-1.7.9s-1.2,1.3-1.7,2.2-.7,1.6-.7,2.2,0,.5.2.7.3.2.5.2c.7,0,1.4-.1,2.1-.3s1.3-.4,1.7-.6c.4-.2.7-.3.8-.3s0,0,.2.2v.4c0,.3-.3.7-.8,1.2-.5.4-1.2.8-1.9,1.1-.8.3-1.4.5-2,.5s-1.2-.4-1.9-1.1-1-1.4-1-2.1.3-1.9.9-3.1,1.4-2.2,2.3-3,1.9-1.3,2.7-1.3h0v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M82.3,135.9c.8-1.1,1.5-1.6,2.3-1.6s1.4.3,1.9.8.8,1.1.8,1.9-.2,1.5-.5,2.2-.8,1.4-1.5,1.9-1.3.7-2.1.7-1-.2-1.4-.7-.6-1-.6-1.7c0-1.2.4-2.3,1.1-3.4h0ZM84.7,138.9c.4-.7.6-1.4.6-2s0-1-.3-1.3c-.4.2-.8.7-1.3,1.5-.4.8-.6,1.4-.6,2s0,.9.2,1.1c.5-.2,1-.7,1.4-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M95.2,131c.4.4.6.8.6,1.2s0,1.1-.2,2.1-.2,1.8-.4,2.4c-.8,3.5-1.4,5.2-1.7,5.2s-.5-.2-.8-.5-.5-.6-.5-.8,0-.5.4-1.5.5-2.2.8-3.8c.3-1.5.4-3,.4-4.4s.2-.4.5-.4.5.2.9.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M101.9,138.3c-.7.4-1.3.6-2,.6s-1.2,0-1.7-.1c0,.3,0,.5,0,.8s0,.4,0,.6.3.2.7.2c.7,0,1.4,0,1.9-.2s.8-.2.8-.2c.4,0,.6.1.6.4s-.3.7-.9,1.1-1.4.5-2.2.5-1.5-.2-2-.8-.8-1.1-.8-1.8.2-1.4.6-2.2.9-1.4,1.6-1.9,1.3-.8,1.9-.8,1.2.3,1.7.9.8,1.2.8,1.8-.3.9-1,1.3h0v-.2ZM100.9,136.4c-.2-.2-.4-.3-.6-.3s-.4.1-.7.4-.6.6-.8,1h.4c1.3,0,2-.2,2-.7s0-.2-.3-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M103.6,139.5c0-.7.2-1.4.7-2.2s1-1.5,1.7-2.1,1.4-.9,2.1-.9.7.2,1.1.6.6.8.6,1.2,0,.4-.3.4-.3,0-.5-.2-.4-.2-.6-.2-.5.2-.9.5-.8.8-1.1,1.3-.5.9-.5,1.2,0,.5.2.6.4.1.8.1.8,0,1.2-.1c.4,0,.6-.2.8-.2s.3-.1.5-.1c.3,0,.4.1.4.4s-.4.9-1.1,1.3-1.5.6-2.3.6-1-.3-1.6-.8-.9-1-.9-1.5h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M114.4,137.1c-.2.5-.3,1.1-.6,1.7s-.3,1.1-.3,1.1h.2c.2,0,.6-.1,1.2-.3s1-.3,1.1-.3c.2,0,.4.2.4.5s-.3.7-1,1.2-1.3.7-2.1.7-.7-.2-1.1-.5-.7-.7-.7-1,.2-.9.4-1.8c.3-.9.5-1.6.6-1.9-.4.1-.7.2-.9.2s-.4-.1-.6-.4-.3-.5-.3-.8.8-.6,2.3-.8c.2-.9.3-1.7.3-2.3s.2-.4.4-.4.6.1,1,.4.6.6.6.9,0,.7-.2,1.2h1.1c.7,0,1.1.2,1.1.5s-.2.4-.6.5-1.1.3-2,.5c0,.3-.2.6-.3,1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M119.4,134.4c.3,0,.7.2.9.6s.4.8.4,1.1-.2.8-.5,2-.7,2.2-1,3.2c0,.4-.4.6-.7.6s-.4,0-.6-.2-.2-.4-.2-.6,0-.9.4-1.9.4-1.9.6-2.6c0-.7.2-1.2.4-1.6,0-.3.2-.5.4-.5h-.1ZM119.2,132.6c0-.2,0-.5.3-.8s.5-.4.7-.4.5.3.8.8.5.9.5,1.1,0,.4-.2.5-.3.2-.5.2c-.3,0-.6-.2-1-.6-.4-.4-.6-.7-.6-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M126.9,134.4c.2,0,.5,0,.7.3s.4.4.4.6c0,.4-.3,1.1-.9,2.4s-1.1,2.3-1.6,3c-.5.8-.9,1.1-1.2,1.1s-.4,0-.6-.3-.5-.4-.5-.6c-.2-.6-.5-1.6-.8-3.1s-.5-2.4-.5-2.9,0-.6.4-.6.7.1,1,.4c.6.4.9,1,1,1.8v1.3c0,.5,0,.9,0,1.3.2-.4.5-1.1.9-2,.3-.9.6-1.5.9-2s.5-.7.7-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M133.8,138.3c-.6.4-1.3.6-2,.6s-1.2,0-1.7-.1c0,.3-.1.5-.1.8s0,.4.1.6.3.2.7.2c.7,0,1.4,0,1.9-.2s.8-.2.8-.2c.4,0,.6.1.6.4s-.3.7-.9,1.1-1.4.5-2.2.5-1.5-.2-2-.8-.8-1.1-.8-1.8.2-1.4.6-2.2c.4-.8.9-1.4,1.6-1.9s1.3-.8,1.9-.8,1.2.3,1.7.9.8,1.2.8,1.8-.3.9-1,1.3h0v-.2ZM132.7,136.4c-.2-.2-.4-.3-.6-.3s-.4.1-.7.4-.6.6-.8,1h.4c1.4,0,2-.2,2-.7s-.1-.2-.3-.4h0Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.9,83.1l3.5-1.2s-2.1-1.5-1.7-4.5c.7-5.1,5.1-11,1.9-17.2,0,0,1.2,2.6-.8,7.2-1.8,4.2-5.9,10.1-3,15.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M78.2,71.9c0-4-4.6-6.9-4.6-6.9,0,0,3.3,3.3,2.6,7.4-.6,4.1-1.4,6.9.7,10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M80.8,81.7s-1.5-3.7,3-4.2c0,0-1.8,0-2.3-1.7s.5-4.1,0-6.3c0,0,0,1-.9,2.9s-1.2,3.5-1.4,5.2c-.2,1.7.7,3.1,1.5,4.1h.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 83.3,
    cy: 74.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M70.8,59.6s-.5,2.3,1.6,4.6c2.1,2.3,3.2,3.7,3.3,6,0,0-.7-2.4-3.6-4.2-2-1.1-4.1-.7-5,0,0,0,.8-1.6,3.3-2.1,0,0-.7-2.3.4-4.3h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 68.5,
    cy: 62.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 77.8,
    cy: 65.4,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 74.9,
    cy: 50.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M71.5,51.9s2.9,1,5.7,4.4c2.8,3.4,3.4,6.8,3.2,8.7,0,0,.8-3.5-.7-6.8-1.8-4.1-2.1-7.9-.5-10,0,0-2.6,1.9-2.5,5.6,0,0-1.9-2-5.2-1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.4,65.2s0,2.3-2.3,2.7c0,0-.2-2.1,2.3-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.7,64.1s-.2,2.3-2.6,2.4c0,0,0-2.1,2.6-2.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M60.9,61.8s-1.4,1.9-3.5.7c0,0,1.2-1.7,3.5-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M60.6,56.3s-2.1,1-3.4-1.1c0,0,1.8-1,3.4,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M63.5,54.9s-2.2.8-3.3-1.3c0,0,1.9-.8,3.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M63.3,50.6s-2.1.9-3.4-1.1c0,0,1.9-1,3.4,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.1,45.9s-2.2-.7-1.8-3c0,0,2,.5,1.8,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M82.2,49.3s1-2.1,3.3-1.3c0,0-.8,1.9-3.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M82,58.6s2.3-.7,3.2,1.5c0,0-2,.7-3.2-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.1,56.8s2.2-.7,3.2,1.4c0,0-1.9.8-3.2-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.6,59.4s-2.6,1.5-4.1-.7c0,0,2.1-1.5,4.1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M70.9,44.4s-2.5-1-1.7-3.6c0,0,2.3.8,1.7,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M76.5,43.3s-1.3-2.3.8-4c0,0,1.3,2-.8,4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.7,59.9s.8,1.3,2.6.4c0,0-1.1-1.2-2.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.2,57.5s.7,1.4-1.1,2.4c0,0-.4-1.6,1.1-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.9,56.8s2.2.6,1.8,3.2c0,0-2.2-.4-1.8-3.2Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.9,57.3s1.2.9,2.6-.6c0,0-1.5-.7-2.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.1,53.4s1.2,1,0,2.6c0,0-1-1.3,0-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.8,54s2.3-.3,2.9,2.3c0,0-2.2.4-2.9-2.3Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.1,44.2s-.7,1.4,1.2,2.4c0,0,.4-1.6-1.2-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.6,46.5s-.8,1.3-2.6.4c0,0,1.1-1.3,2.6-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.3,43.4s.7,2.2-1.7,3.3c0,0-.9-2,1.7-3.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.8,62.2s1.8.7,2.9-1.3c0,0-2-.7-2.9,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M65.9,57s-1.3,1.5.2,3.2c0,0,1.3-1.7-.2-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.1,58.3s.5,2.7,3.7,2.2c0,0-.7-2.7-3.7-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M71.3,46.7s.9,1.7,3,1c0,0-1-1.8-3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M77.1,44.9s-1.9.3-1.9,2.5c0,0,2.1-.4,1.9-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.4,43.4s-1.4,2.4,1.4,4.1c0,0,1.3-2.5-1.4-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63.9,51.3s1.8,1,3.4-.9c0,0-2.1-1-3.4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68.2,46s-1.6,1.4-.3,3.5c0,0,1.7-1.6.3-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63.9,46.9s0,3,3.7,3c0,0-.3-3.1-3.7-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M80.5,50s-1.8,1.1-.7,3.4c0,0,1.9-1.3.7-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83.2,56.2s-.5-2.1-3-1.8c0,0,.7,2.2,3,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.4,52s-2.7-1.3-4.4,1.8c0,0,2.9,1.2,4.4-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M68,50.6s1,1.6,2.6.7c0,0-.8-1.7-2.6-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.4,54.7s2.2-1.5,4.1,1c0,0-2.4,1.3-4.1-1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M149.3,96.6c-1.7,0-3.4-.2-5.3-.2-3.6,0-7.3.2-10.5.5.2,2.2.2,2.4.3,4v2.1c.2,2.2,5.2,3.6,10.3,3.7,8.1.2,18.2-2.2,19.8-4.9-.7-1.8-3.5-4.2-14.6-5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M19.9,90.1c-.5.6-.8,1.4-.8,2.2.9,0,1.9.2,2.9.2,1.9,0,3.8.2,5.8.2h2.5v-.3c0-30.4,24.6-55,55-55s39,11.6,48.3,28.7c1.7,0,3.4-.2,5-.2s2.9,0,4.2,0c1.1,0,2.1,0,3.1.2-.2-1.1-.9-2.1-1.9-2.5l-2.3-1.1c-1.5-.7-2.6-2.6-2.5-4.2l.2-2.6c.1-1.6-1.1-3.3-2.7-3.6l-2.5-.6c-1.6-.4-3.1-2-3.3-3.6l-.3-2.6c-.2-1.6-1.7-3-3.4-3h-2.6c-1.6,0-3.4-1.4-4-2.9l-.9-2.4c-.5-1.5-2.3-2.6-3.9-2.3l-2.5.5c-1.6.3-3.6-.6-4.5-2l-1.4-2.2c-.9-1.4-2.8-2-4.3-1.4l-2.4,1c-1.5.6-3.7.2-4.8-1l-1.8-1.9c-1.1-1.2-3.1-1.4-4.5-.5l-2.1,1.5c-1.3.9-3.5.9-4.9,0l-2.1-1.5c-1.3-.9-3.4-.7-4.5.5l-1.8,1.9c-1.1,1.2-3.3,1.6-4.8,1l-2.4-1c-1.5-.6-3.4,0-4.3,1.4l-1.4,2.2c-.9,1.4-2.9,2.3-4.5,2l-2.5-.5c-1.6-.3-3.4.7-3.9,2.3l-.9,2.4c-.5,1.5-2.3,2.8-4,2.9h-2.6c-1.6,0-3.1,1.5-3.4,3.1l-.3,2.6c-.2,1.6-1.7,3.3-3.3,3.6l-2.5.6c-1.6.4-2.8,2-2.7,3.6l.2,2.6c.1,1.6-1,3.5-2.4,4.2l-2.3,1.1c-1.5.7-2.3,2.6-1.8,4.1l.7,2.5c.5,1.6-.2,3.7-1.5,4.7l-2.1,1.6c-1.3,1-1.7,3-.9,4.4l1.2,2.3c.8,1.4.6,3.6-.5,4.9l-1.7,2h0l.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M22,92.6c1.4,0,2.8,0,4.2.2-.2-3.7-.1-2.7-.3-6.6-.1-2.2-3.2-3-6.5-3.1h-.6c-5.3,0-11.8,1.9-12.7,4.4.6,2,5,4.4,15.9,5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M6.6,89.8l1.9,19.5c.6,6.5,1.3,8.9,10.6,10.9,3.9.8,7.9,1.3,12.4,1.3s12.4-.8,17.8-1.5c14.4-2,28.1-7.2,41.4-12.2,10.5-4,21.3-8.1,32.5-10.7,3.1-.7,11.7-1.8,19.9-1.8s3.7,0,5.3.2c8.4.5,13.6,1.8,15.5,3.8l-1.8-19.5c-.7-7.6-3.7-11-20.3-12-1.3,0-2.7,0-4.1,0-4.9,0-10.1.5-16.4,1.5-14.1,2.3-26.9,7.1-39.3,11.8-16.7,6.3-34,12.8-54,12.8s-3.8,0-5.8-.2c-8.4-.5-13.6-1.8-15.5-3.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M50.4,113.2c0,.6-.3.9-1.1,1.1-1.1.2-2.4-.2-3.8-1.2s-2.5-2-3.2-3.2c0,.7-.2,1.2-.3,1.5s0,.7-.2,1.2c0,.6-.2,1-.2,1.2,0,.3,0,.6-.2.9,0,.6-.3.9-.5.9-.3,0-.8-.2-1.3-.6s-.8-.9-.9-1.2c0-.3,0-1,.2-2,.5-3,.7-5.7.5-8-.3-.2-.6-.4-.9-.8s-.4-.7-.5-.9c0-.4.4-1,1.5-1.6,1-.6,2.3-1.1,3.7-1.3,1.5-.2,2.7,0,3.8.5s1.7,1.4,1.9,2.5c0,.8,0,1.6-.4,2.5s-.8,1.5-1.3,2l-1.4,1.4c-.4.4-.6.7-.6.8,0,.3.2.7.5.9.3.3.7.6,1.1.9s.9.6,1.2.9.6.4.8.6.4.3.7.5c.4.3.7.6.7.8h0l.2-.3ZM45.8,102.6c0-.6-.7-.8-1.9-.6-.6,0-1.2.3-1.9.8.4.5.7,1,.8,1.4,0,.8.2,1.8,0,2.8,0,0,.4-.4.8-.7.4-.4.7-.6.9-.9s.4-.5.7-.8c.5-.6.7-1.3.6-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M52.1,104.5c.7-1.9,1.5-2.9,2.6-3.2s2.1,0,3,.4c.9.6,1.5,1.4,1.8,2.4.3,1.1.3,2.2,0,3.4-.2,1.2-.7,2.3-1.4,3.3s-1.6,1.6-2.6,1.8c-.8.2-1.5,0-2.3-.5s-1.2-1.3-1.5-2.3c-.5-1.7-.4-3.5.3-5.4h.1ZM56.6,107.9c.3-1.2.3-2.2,0-3.1-.2-.9-.5-1.5-.9-1.7-.5.5-.9,1.4-1.2,2.7s-.3,2.3,0,3.2.4,1.4.7,1.5c.7-.5,1.1-1.4,1.4-2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M66,97.9c.5-.2,1.1,0,1.9.4s1.1.9,1.3,1.4c0,.3,0,.5-.3.6s-.4,0-.8,0-.7,0-1,0-.8.4-1.3.8c-.6.4-.8.8-.6,1.2,0,0,.3.3.8.4s1,.3,1.5.4,1.1.4,1.6.7c.5.4.9.8,1.1,1.4s0,1.3-.7,2.1-1.5,1.5-2.6,1.8c-1.1.4-2.2.4-3.1.2-1-.2-1.5-.6-1.7-1.2-.2-.5,0-.9.4-1h.7c.8.2,1.7,0,2.8-.3s1.5-.6,1.4-.9c0-.3-.4-.5-.9-.7s-1-.4-1.6-.5-1.1-.3-1.6-.6c-.5-.3-.9-.6-1-1-.2-.7.2-1.8,1.2-3.1,1.1-1.3,2-2.1,2.7-2.4h0l-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M71.3,90.5c.7.4,1.2.9,1.4,1.4s.5,1.5.8,3,.6,2.6.7,3.5c.7,5.3.8,8.1.3,8.2-.3,0-.8,0-1.4-.3s-1-.6-1.1-1c0,0,0-.8-.2-2.3,0-1.5-.4-3.4-.8-5.8-.4-2.3-1-4.5-1.7-6.5,0-.4,0-.7.4-.8.3,0,.9,0,1.6.4h0v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M75.3,91.6c0-.4,0-.8,0-1.3s.4-.8.7-.9.8,0,1.5.7,1.1,1,1.2,1.4c0,.3,0,.6,0,.9s-.3.4-.6.5c-.4,0-.9,0-1.7-.3-.7-.3-1.1-.7-1.3-1h.2ZM76.5,94c.5-.2,1,0,1.6.3s1,.9,1.1,1.4c0,.3.2,1.3.3,3s.2,3.4.3,5c0,.6-.2,1-.7,1.2-.3,0-.6,0-.9,0s-.5-.4-.7-.7c0-.4-.3-1.3-.5-2.9s-.4-2.9-.6-4-.3-1.9-.3-2.4,0-.8.3-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M87,90.1c.7-.3,1.4-.2,2.2.2.8.4,1.3,1,1.6,1.7.4,1.2.7,2.4.8,3.8s0,2.5,0,3.4c-.2.8-.5,1.3-1,1.5s-.8,0-1-.7c-.2-.5-.3-1.6-.4-3.2,0-1.3-.3-2.3-.5-2.8s-.4-.8-.5-.7c-.2,0-.3.2-.4.5s-.2.4-.2.6,0,.4-.2.7c0,.3,0,.5-.2.7,0,.2,0,.5,0,.8,0,.3,0,.6,0,.8s0,.5,0,.8c-.4,2.8-.9,4.4-1.6,4.6-.3,0-.7,0-1.4-.3s-1-.6-1.1-.8v-3.3c0-.3,0-.7-.2-1,0-.4-.2-.6-.2-.8s0-.5-.3-.9c-.5-1.8-.8-2.8-.8-3s0-.4.2-.4c.5-.2,1.1-.2,1.7,0s1,.5,1.1.9c.3.8.5,2.1.7,3.9.3-1.9.6-3.4,1-4.7.4-1.3.8-2,1.3-2.2h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M97.8,79.9c.3,0,.9,0,1.6.5s1.2.9,1.4,1.4c0,.3.2,1.4.4,3.5.2,2.1.3,3.3.3,3.7.5,5.1.5,7.7,0,7.9-.3,0-.7,0-1.1-.2-.5-.2-.8-.5-.9-.8v-.2c-1,1.6-1.8,2.5-2.4,2.7s-1.3,0-2-.4c-.8-.4-1.2-.9-1.4-1.5s-.3-1.1-.4-1.8,0-1.4,0-2.3.2-1.6.4-2.4c.2-.8.5-1.4.9-2s.9-1,1.5-1.2c.9-.3,1.7,0,2.6.6-.4-3.5-.7-5.8-1.1-6.8,0-.4,0-.7.4-.8h-.2ZM96.4,95.6c.3,0,.8-.6,1.4-1.5s1-1.8,1.1-2.9c0,0,0-.3-.3-.7,0-.4-.4-.7-.7-.9s-.6-.3-.8-.3c-.4,0-.7.5-1,1.1s-.3,1.2-.4,1.9c0,1.4,0,2.5.3,3.1,0,0,0,.2,0,.2h.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M112.7,87.1c.3.2.5.3.5.5v5.4c0,0-.2.2-.4.3-.2,0-.5,0-.9-.4-.4-.3-.7-.7-1-1.2-.9,1.7-1.9,2.7-2.8,2.9-.6.2-1.3,0-2.2-.5s-1.4-1-1.6-1.7,0-1.7,0-3.1c.3-1.4.8-2.8,1.5-4.1s1.6-2.1,2.7-2.4c.6-.2,1.4,0,2.3.5s1.5,1,1.7,1.6,0,1.3,0,2.1h.1ZM107.5,92.1c.6-.2,1.2-.7,1.9-1.7.7-1,1-2.1.9-3.3,0-.2,0-.3.3-.4-.3-.8-.5-1.1-.7-1.1-.6.2-1.1.7-1.6,1.6s-.8,1.8-1.1,2.8c-.2.9-.3,1.6-.2,2,0,0,0,.2,0,.2h.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M116.9,75.9c.7.5,1.1,1,1.2,1.6s.2,1.6.4,3.1c0,1.5.2,2.7.2,3.6,0,5.4-.4,8.1-.9,8.2-.3,0-.8,0-1.3-.5-.6-.4-.9-.8-.9-1.1,0,0,0-.8,0-2.3s0-3.5,0-5.8-.3-4.6-.8-6.6c0-.4,0-.7.5-.8.3,0,.8,0,1.5.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M128.8,85.2c-.9.7-1.8,1.1-2.8,1.3s-1.8.2-2.5,0v1.2c0,.4.2.7.3.8s.5.2,1,0c1.1-.2,2-.4,2.7-.7.7-.3,1.1-.5,1.1-.5.6,0,.9,0,1,.5,0,.6-.3,1.2-1.2,1.8-.9.6-1.9,1-3.1,1.2s-2.2,0-3.1-.7c-.8-.7-1.3-1.5-1.5-2.5,0-1,0-2.2.4-3.4.4-1.2,1.1-2.3,1.9-3.2.8-.9,1.7-1.4,2.6-1.5s1.8.2,2.7,1c.9.8,1.4,1.6,1.5,2.5.1.7-.3,1.4-1.2,2.1h.2ZM126.8,82.6c-.3-.2-.6-.3-.9-.3s-.6.3-.9.7c-.4.4-.7,1-1,1.6h.6c2-.3,2.9-.8,2.8-1.5,0,0-.2-.3-.5-.6h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M91.2,131.5c.4.4.6.8.6,1.2s0,1.1-.2,2.1-.2,1.8-.4,2.4c-.8,3.5-1.4,5.3-1.7,5.3s-.5-.2-.8-.5-.5-.6-.5-.8,0-.5.4-1.5.5-2.3.8-3.8c.3-1.6.4-3,.4-4.4s.2-.4.5-.4.5.2.9.6h0v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M38.4,132c.5,0,1.3-.1,2.4-.1s1.9,0,2.5.3c.6.2.9.4.9.7s0,.2-.2.3c0,0-.2.1-.3.1h-2.9c-.2,0-.7,0-1.5.2h0c0,.4-.2,1.3-.5,2.8h3.1c.2,0,.3,0,.4.1s.2.2.2.3c0,.3-.2.5-.5.7s-.7.4-1.2.5c-1,.2-1.8.4-2.5.4-.3,1.2-.5,2-.5,2.3s0,.5-.2.8c0,.5-.2.7-.4.7s-.5-.2-.9-.7-.5-.8-.5-1c0-.4.2-1.6.7-3.7.5-2.1.8-3.4.8-3.9h0v-.4c0-.3.4-.5,1-.6h0v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M45,136.5c.8-1.1,1.5-1.6,2.3-1.6s1.4.3,1.9.8.8,1.1.8,1.9-.2,1.5-.5,2.2-.9,1.4-1.5,1.9-1.3.7-2.1.7-1-.2-1.4-.7-.6-1-.6-1.7c0-1.2.4-2.4,1.2-3.4h-.1ZM47.4,139.5c.4-.7.6-1.4.6-2s0-1-.3-1.3c-.4.2-.9.8-1.3,1.5-.4.8-.6,1.5-.6,2s0,1,.2,1.1c.5-.2,1-.7,1.4-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M51.9,136.5c.8-1.1,1.5-1.6,2.3-1.6s1.4.3,1.9.8.8,1.1.8,1.9-.2,1.5-.5,2.2-.9,1.4-1.5,1.9-1.3.7-2.1.7-1-.2-1.4-.7-.6-1-.6-1.7c0-1.2.4-2.4,1.2-3.4h-.1ZM54.4,139.5c.4-.7.6-1.4.6-2s0-1-.3-1.3c-.4.2-.9.8-1.3,1.5-.4.8-.6,1.5-.6,2s0,1,.2,1.1c.5-.2,1-.7,1.4-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M64.2,130.8c.2,0,.6.2.9.6.4.4.6.8.6,1.2s-.2.9-.5,2.3c-.3,1.3-.6,2.2-.6,2.4-.8,3.3-1.4,5-1.7,5s-.4-.1-.7-.4c-.3-.2-.4-.5-.4-.7s0,0,0-.1c-1,.8-1.7,1.2-2.1,1.2s-.9-.2-1.3-.7c-.4-.4-.6-.9-.6-1.2s0-.8.2-1.2.3-.9.5-1.4.5-1,.8-1.4.6-.8,1-1.1.8-.4,1.2-.4c.6,0,1.2.3,1.6.9.5-2.3.8-3.8.8-4.6s0-.4.4-.4h0ZM59.8,140.5c.2,0,.7-.2,1.3-.6s1-.9,1.3-1.6v-.5c0-.3,0-.5-.3-.7-.2-.2-.3-.3-.5-.3-.3,0-.6.2-.9.5s-.5.7-.6,1.1c-.3.9-.5,1.6-.5,2s0,.1,0,.2,0,0,.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M78,131.7c.3,0,.6.2.9.7s.5.9.5,1.2,0,.5-.2.5h-.9c-.5,0-1.1.3-1.7.9-.7.6-1.2,1.4-1.7,2.2-.5.9-.7,1.6-.7,2.2s0,.5,0,.7c0,.1.3.2.5.2.7,0,1.4-.1,2.1-.3s1.3-.4,1.7-.6c.5-.2.7-.3.8-.3s0,0,.2.2v.4c0,.3-.3.7-.8,1.2-.5.4-1.2.8-1.9,1.2-.8.3-1.4.5-2.1.5s-1.3-.4-1.9-1.1c-.7-.7-1-1.4-1-2.1s.3-2,.9-3.1,1.4-2.2,2.3-3.1,1.9-1.3,2.8-1.3h0v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M82.3,136.5c.8-1.1,1.5-1.6,2.3-1.6s1.4.3,1.9.8.8,1.1.8,1.9-.2,1.5-.5,2.2-.9,1.4-1.5,1.9-1.3.7-2.1.7-1-.2-1.4-.7-.6-1-.6-1.7c0-1.2.4-2.4,1.2-3.4h-.1ZM84.7,139.5c.4-.7.6-1.4.6-2s0-1-.3-1.3c-.4.2-.9.8-1.3,1.5-.4.8-.6,1.5-.6,2s0,1,.2,1.1c.5-.2,1-.7,1.4-1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M95.3,131.5c.4.4.6.8.6,1.2s0,1.1-.2,2.1-.2,1.8-.4,2.4c-.8,3.5-1.4,5.3-1.7,5.3s-.5-.2-.8-.5-.5-.6-.5-.8,0-.5.4-1.5.5-2.3.8-3.8c.3-1.6.4-3,.4-4.4s.2-.4.5-.4.5.2.9.6h0v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M102.1,138.9c-.7.4-1.3.6-2,.6s-1.3,0-1.7-.1c0,.3,0,.5,0,.8s0,.4,0,.6.3.2.7.2c.7,0,1.4,0,1.9-.2s.8-.2.8-.2c.4,0,.6.1.6.4s-.3.7-1,1.1-1.4.5-2.2.5-1.5-.3-2-.8-.8-1.1-.8-1.8.2-1.4.6-2.2,1-1.4,1.6-1.9,1.3-.8,1.9-.8,1.2.3,1.8.9.8,1.2.8,1.8-.3.9-1,1.3h0v-.2ZM101,137c-.2-.2-.4-.3-.6-.3s-.4.1-.7.4c-.3.3-.6.6-.8,1h.4c1.4,0,2-.2,2-.7s0-.2-.3-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M103.8,140.1c0-.7.2-1.4.7-2.2.4-.8,1-1.5,1.7-2.1s1.4-.9,2.1-.9.7.2,1.1.7.6.8.6,1.2,0,.4-.4.4-.3,0-.5-.2c-.2-.1-.4-.2-.6-.2s-.5.2-.9.5-.8.8-1.1,1.3c-.3.5-.5.9-.5,1.2s0,.5.2.6c0,0,.4.1.8.1s.8,0,1.2-.1c.4,0,.6-.2.8-.2s.3-.1.5-.1c.3,0,.4.1.4.3,0,.4-.4.9-1.1,1.3s-1.5.7-2.3.7-1-.3-1.7-.8-.9-1-.9-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M114.8,137.7c-.2.5-.3,1.1-.6,1.8s-.3,1.1-.3,1.1h.2c.2,0,.6-.1,1.2-.3s1-.3,1.1-.3c.2,0,.4.2.4.5s-.3.7-1,1.2-1.4.7-2.1.7-.7-.2-1.1-.5-.7-.7-.7-1,.2-.9.5-1.8c.3-.9.5-1.6.6-1.9-.4.1-.7.2-.9.2s-.4-.1-.6-.4-.3-.5-.3-.8.8-.6,2.3-.8c.2-.9.3-1.7.3-2.3s0-.4.4-.4.6.2,1,.5.6.6.6.9,0,.7-.2,1.2h1.1c.7,0,1.1.2,1.1.5s-.2.4-.6.5-1.1.3-2,.5c0,.3-.2.6-.4,1.1h0v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M119.8,134.9c.3,0,.7.2.9.6.3.4.4.8.4,1.1s-.2.8-.5,2-.7,2.2-1,3.2c0,.4-.4.6-.7.6s-.4,0-.6-.2-.2-.4-.2-.6,0-.9.4-1.9.4-1.9.6-2.6c0-.7.3-1.2.4-1.6,0-.3.3-.5.4-.5h-.1ZM119.6,133.1c0-.3,0-.5.4-.8s.5-.4.7-.4.5.3.8.8.5.9.5,1.1,0,.4-.2.5-.3.2-.5.2c-.3,0-.6-.2-1-.6-.4-.4-.6-.7-.6-.9h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M127.4,134.9c.3,0,.5,0,.8.3.3.3.4.4.4.6,0,.3-.3,1.2-.9,2.4s-1.1,2.3-1.6,3.1-.9,1.2-1.2,1.2-.4,0-.6-.3-.5-.4-.5-.6c-.2-.6-.5-1.6-.9-3.1-.3-1.5-.5-2.5-.5-2.9s0-.6.4-.6.7.1,1,.4c.6.4.9,1,1,1.8v1.3c0,.5,0,.9,0,1.3.2-.4.5-1.1.9-2,.3-.9.6-1.6.9-2.1s.5-.7.7-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M134.3,138.9c-.7.4-1.3.6-2,.6s-1.3,0-1.7-.1c0,.3-.1.5-.1.8s0,.4.1.6.3.2.7.2c.7,0,1.4,0,1.9-.2s.8-.2.8-.2c.4,0,.6.1.6.4s-.3.7-1,1.1-1.4.5-2.2.5-1.5-.3-2-.8-.8-1.1-.8-1.8.2-1.4.6-2.2c.4-.8,1-1.4,1.6-1.9s1.3-.8,1.9-.8,1.2.3,1.8.9.8,1.2.8,1.8-.3.9-1,1.3h0v-.2ZM133.2,137c-.2-.2-.4-.3-.6-.3s-.4.1-.7.4c-.3.3-.6.6-.8,1h.4c1.4,0,2-.2,2-.7s-.1-.2-.3-.4h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogonew);
export default __webpack_public_path__ + "static/media/logonew.f78e3e85941a90eb7bbc52ad594b7b24.svg";
export { ForwardRef as ReactComponent };